import useMutationApi from 'src/api/useMutationApi';

const useTriggerFamousShipmentFetch = (onSuccess?: () => void) => {
  return useMutationApi<{ famousShipmentId: string }>({
    endpoint: 'famous/shipments/fetch',
    method: 'POST',
    options: {
      onSuccess,
    },
  });
};

export default useTriggerFamousShipmentFetch;
